import React from "react"
import DodonesResolverDay from "site/dodones_resolver/Day"

export default () => {
  return <div className='frow'>
           <div className="darkest-transparent-box p-d"> Sua Mãe </div>
           <div className="flex-1 p-d">
             <DodonesResolverDay />
           </div>
         </div>
}
